import React from 'react';
import { useHistory } from 'react-router-dom';
import * as R from 'ramda';
import { PersonalServices, SocialNetworksOptions, AssuranceOptions } from '../../../../../constants/utils/connectionTypes';
import * as Loadings from '../../../../../constants/loadings/facilita/deathDeclaration';

import {updateUserConnectionBatch, updateOnboardingStep}  from '../../../../../actions/facilita-api';
import { useDispatch } from 'react-redux';


export const DemarchesPersonalisees = ({userId, setSubStep, setSelectedUserConnection, selectedUserConnection, isLoading}) => {
    const dispatch = useDispatch();
    const history = useHistory();
    return (
      <article className="view-calc pt-0 mb-auto">
        <div className="container-fluid">
            <header className="rounded-bottom-left-sm rounded-top-right-sm mb-0 alert alert-primary text-center py-2">
                <h1 className="text-primary font-weight-bolder mt-2 mb-2">Démarches personnalisées</h1>
            </header>
        </div>
        <div className="auto-view py-4 py-lg-0 mt-lg-sm">
            <div className="container-fluid">
                <section className="block">
                    <h4 className="h4 text-uppercase text-secondary font-weight-bolder mt-0 mb-1">Démarches déjà comprises dans le service : </h4>
                    <p className="small o-50">Déselectionnez les démarches que le défunt n'a pas.</p>
                    <form className="pb-sm">
                        <div className="grid grid-sm-min grid-lg-tight grid-xl-single g-spacer">
                            {
                                R.sortWith([R.ascend(R.prop('title'))])(Object.values(PersonalServices)).map((srv, index) => {
                                    return (
                                        <div key={index + srv.title} className="form-group col col-lg-3 col-xl-2">
                                            <div className={"card p-2 text-center picker-card" + (selectedUserConnection.includes(srv.connectionType) ? " active" : "")} onClick={() => {
                                                if(!selectedUserConnection.includes(srv.connectionType)){
                                                setSelectedUserConnection([...selectedUserConnection, srv.connectionType]);
                                                }else{
                                                setSelectedUserConnection(selectedUserConnection.filter(s => s !== srv.connectionType));
                                                }
                                                }}>
                                                <img className="img-fluid mx-auto mb-1 h-6 py-1 mt-auto" src={srv.icon} alt={srv.title} />
                                                <h2 className="h6 text-uppercase font-weight-bolder mt-auto">{srv.title}</h2>
                                                {
                                                    !R.isNil(srv.desc) && srv.desc !== "" ?
                                                        <p className="small o-50 mt-0 mb-auto lh-copy h-6">{srv.desc.map((d, ind) => { return <React.Fragment key={ind}>{d}{ind !== (srv.desc.length - 1) ? <br /> : ''}</React.Fragment> })}</p>
                                                    :
                                                        ''
                                                }

                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </form>
                </section>
                {/* <section className="block mt-5 pt-2">
                    <h4 className="h4 text-uppercase text-secondary font-weight-bolder mt-2 mb-3">RÉSEAUX SOCIAUX ( à sélectionner) </h4>
                    <form className="pb-sm">
                        <div className="grid grid-sm-min grid-lg-tight grid-xl-single g-spacer">
                            {
                                    R.sortWith([R.ascend(R.prop('title'))])(Object.values(SocialNetworksOptions)).map((srv, index) => {
                                    return (
                                        <div key={'social'+(index + srv.title)} className="form-group col col-lg-3 col-xl-2">
                                            <div className={"card card-body pt-2 text-center picker-card" + (selectedUserConnection.includes(srv.connectionType) ? " active" : "")}  onClick={() => {
                                                if(!selectedUserConnection.includes(srv.connectionType)){
                                                    setSelectedUserConnection([...selectedUserConnection, srv.connectionType]);
                                                }else{
                                                    setSelectedUserConnection(selectedUserConnection.filter(s => s !== srv.connectionType));
                                                }
                                            }}>
                                                <img className="img-fluid mx-auto my-3 mb-2 h-6 py-1" src={srv.icon} alt={srv.title} />
                                                <h2 className="h6 text-uppercase font-weight-bolder container-slim m-auto">{srv.title}</h2>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </form>
                </section> */}
                <section className="block mt-5 pt-2">
                    <h4 className="h4 text-uppercase text-secondary font-weight-bolder mt-2 mb-3">ASSURANCES ( à selectionner) </h4>
                    <form className="pb-sm">
                        <div className="grid grid-sm-min grid-lg-tight grid-xl-single g-spacer">
                            {
                                    R.sortWith([R.ascend(R.prop('title'))])(Object.values(AssuranceOptions)).map((srv, index) => {
                                    return (
                                        <div key={'assurance'+(index + srv.title)} className="form-group col col-lg-3 col-xl-2">
                                            <div className={"card card-body pt-2 text-center picker-card" + (selectedUserConnection.includes(srv.connectionType) ? " active" : "")} data-toggle={(srv.tooltip !== undefined ? "tooltip" : "")} data-placement={(srv.tooltip !== undefined ? "top" : "")} data-html={(srv.tooltip !== undefined ? "false" : "")} title={(srv.tooltip !== undefined ? srv.tooltip : "")} onClick={() => {
                                                if(!selectedUserConnection.includes(srv.connectionType)){
                                                    setSelectedUserConnection([...selectedUserConnection, srv.connectionType]);
                                                }else{
                                                    setSelectedUserConnection(selectedUserConnection.filter(s => s !== srv.connectionType));
                                                }
                                            }}>
                                                <img className="img-fluid mx-auto my-3 mb-2 h-6 py-1" src={srv.icon} alt={srv.title} />
                                                <h2 className="h6 text-uppercase font-weight-bolder container-slim m-auto">{srv.title}</h2>
                                                {
                                                    !R.isNil(srv.desc) && srv.desc !== "" ?
                                                        <p className="small o-50 mt-0 mb-auto lh-copy">{srv.desc.map((d, ind) => { return <React.Fragment key={ind}>{d}{ind !== (srv.desc.length - 1) ? <br /> : ''}</React.Fragment> })}</p>
                                                    :
                                                        ''
                                                }
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </form>
                </section>
            {/* </div>
            <div className="container-fluid"> */}
                <footer className="flex-md-row align-items-center mt-auto mb-0 text-lg-right w-100">
                    <button className="btn btn-faded px-md-gutter mr-3 ml-auto" onClick={() => { setSubStep(1) }}>Retour</button>

                    {
                        isLoading.includes(Loadings.ADDING_USER_CONNECTION_BATCH) ?
                            <button className="btn btn-info loading-btn px-md-gutter px-4 loading-btn show" disabled={true}>Passer à l'étape suivante<div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div></button>
                        :
                            <button className={"btn btn-info loading-btn px-md-gutter px-4 loading-btn"}
                            onClick={() =>{
                                dispatch(updateUserConnectionBatch(userId, selectedUserConnection))
                                .then(() => {
                                    dispatch(updateOnboardingStep(userId, 6))
                                    .then(() => {
                                        history.push(`/facilita/${userId}`)
                                    })
                                })

                            } }>Passer à l'étape suivante
                                <div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>
                            </button>
                    }
                    <h6 className="my-3 my-md-0 mr-auto order-lg-first fs-3 o-60">* champs obligatoires</h6>
                </footer>
            </div>
        </div>
      </article>
  )
}